export default "__VITE_ASSET__DITbQrLM__"